import { Component, Input, OnInit } from '@angular/core';
import { map } from 'rxjs';
import { IAMService, UserIdentifier } from '@vendasta/iamv2';
import { CommonModule } from '@angular/common';
import { ObservableWorkState } from '@vendasta/rx-utils/work-state';
import { GalaxyLoadingSpinnerModule } from '@vendasta/galaxy/loading-spinner';

@Component({
  selector: 'email-user-name-cell',
  template: `
    <ng-container *ngIf="loading$ | async; else display">
      <glxy-loading-spinner
        [size]="'small'"
        [fullWidth]="true"
        [fullHeight]="false"
        [inline]="true"
      ></glxy-loading-spinner>
    </ng-container>

    <ng-template #display>
      <div *ngIf="error$ | async; else value">--</div>
      <ng-template #value>
        <div>{{ text$ | async }}</div>
      </ng-template>
    </ng-template>
  `,
  imports: [CommonModule, GalaxyLoadingSpinnerModule],
  providers: [IAMService],
})
export class UsernameCellComponent implements OnInit {
  @Input() partnerId: string;
  @Input() emailAddress: string;

  private readonly state = new ObservableWorkState<string>();
  public readonly loading$ = this.state.isLoading$;
  public readonly text$ = this.state.workResults$;
  public readonly error$ = this.state.isSuccess$.pipe(map((m) => !m));

  constructor(private readonly iamService: IAMService) {}

  ngOnInit(): void {
    this.state.startWork(
      this.iamService
        .getUser(new UserIdentifier({ namespacedEmail: { namespace: this.partnerId, email: this.emailAddress } }))
        .pipe(map((user) => (user ? `${user.firstName} ${user.lastName}`.trim() : ''))),
    );
  }
}
